export default __webpack_public_path__ + "static/media/Interactive Map.1fbf382c.svg";